import {ModelBase} from "./base"
import format from "string-format"
import api from "../api"

class Well extends ModelBase {

	constructor(plate, data, rootState) {
		super(data)

		this._plate = plate
		this.title = !data.empty
			? plate.plate_frame.well_num_to_name(data.well_num)
			: "N0"

		this.sample = data.sample_id != null
			? rootState.sample.samples[data.sample_id]
			: null

		this.treat = data.treat_id != null
			? rootState.lists.treats[data.treat_id]
			: null

		this.color = data.color == null ? '' : data.color

		this.probePlex = data.probePlex_id != null
			? rootState.lists.probePlexes[data.probePlex_id]
			: null

		this._spectra = null
		this._spectra_loading = false
		// хотел запустить загрузку данных лунки spectra сразу
		// при создании объекта, но выяснилось, что первый
		// ответ  приходит только после того как сервер
		// обработает все запросы на данные всех лунок

		this._probe_data = null
		this._probe_data_loading = false

		console.debug('Well.ctor() end')
	}

	get plate() {
		return this._plate
	}

	/**
	 * данные измерения флуоресценции, закачиваем по необходимости
	 */
	get spectra() {
		return this._spectra
	}

	load_spectra(dispatch) {
		const well = this
		return this._spectra === null
			? dispatch('plate/load_well_spectra', {well})
			: Promise.resolve(true)
	}

	get probe_data() {
		return this._probe_data
	}

	load_probe_data(dispatch) {
		const well = this
		return this._probe_data === null
			? dispatch('plate/load_well_probe_data', {well})
			: Promise.resolve(true)
		// данные зондов лунки будут установлены в мутации LOAD_WELL_PROBE_DATA
	}
}

export {Well}